export default {
	optionsListener() {
		$("#game_cloned_from_id").on(
			"change",
			pp.backend.gameCloning.updateFormProperties,
		);

		// Make double sure that the entered Game name has 5 characters *excluding* leading and trailing spaces.
		$(".j-init-cloning-button").on("click", () => {
			// @ts-expect-error
			$("#game_name").val($("#game_name").val().trim());
			// Trigger validation again
			$("#game_name")
				.trigger("change.ClientSideValidations")
				.trigger("focusout.ClientSideValidations");
		});

		$(document)
			.off("change keyup", "#actors_number")
			.on(
				"change keyup",
				"#actors_number",
				pp.backend.gameCloning.handleActorsNumberChange,
			);
		// don't submit form on enter
		$(document)
			.off(
				"keydown",
				"form#new_game input[type='text'], form#new_game input[type='number']",
			)
			.on(
				"keydown",
				"form#new_game input[type='text'], form#new_game input[type='number']",
				(e) => {
					if (e.keyCode != 13) return; // not enter

					e.preventDefault();
					e.stopPropagation();
				},
			);
		$("#actors_number").trigger("keyup"); // trigger once now

		// Make sure that no form is being submitted without any selected Actor tpl ids
		$(document)
			.off("change", "#game_actor_tpl_ids")
			.on("change", "#game_actor_tpl_ids", function (e) {
				$(".j-init-cloning-button").prop(
					"disabled",
					!$(this).children(":selected").length,
				);
			});

		$("#game_actor_tpl_ids").trigger("change"); // trigger once now

		pp.backend.gameCloning.initValidators();

		if (!$("#game_token_id").length) {
			return;
		}
		$(".j-update-clone-data")
			.off("click")
			.on("click", ({ currentTarget }) => {
				// @ts-expect-error
				$(currentTarget).append(pp.loaderHtml).addClass("disabled");
				pp.backend.gameCloning.saveTokenConfig(
					pp.backend.gameCloning.updateCloneDataCallback,
				);
			});
	},

	updateCloneDataCallback(statusCode, errorMsg) {
		$(".j-update-clone-data")
			.removeClass("disabled")
			.find(".lds-ring")
			.remove();
		pp.gameTokenLobby.excludedGenericUserIds = []; // Assume that GameTokenLobbyUser records have been deleted
		if (!errorMsg) {
			pp.notifications.display(
				"notice",
				I18n.t("helpers.submit.updated", {
					model: I18n.t(
						"backend.game_cloning_fields.game_token_clone_settings",
					),
				}),
			);
		} else {
			if (statusCode == 403) {
				// Forbidden
				pp.notifications.display("error", I18n.t("global.access_denied"), {
					dismissable: true,
				});
				Turbolinks.visit("/");
			} else {
				pp.notifications.display(
					"error",
					`${I18n.t("global.error")}: ${errorMsg}`,
				);
			}
		}
	},

	updateFormProperties() {
		const thisGameId = $("#game_cloned_from_id").val();
		// pp.log("BACKEND Game tpl id:", thisGameId);
		// block submit button immediately to avoid cloning with faulty options

		$(".j-clone-data-loading-spinner").removeClass("hidden");
		$(".j-init-cloning-button, #game_name").prop("disabled", true);

		$.ajax({
			url: `/games/${thisGameId}/cloning_form_properties`,
			dataType: "json",
			data: {
				game_token: $("#game_token").val(),
				name_val: $("#game_name").val(),
			},
		}).done(({ formHtml, errorHtml, redirectUrl }) => {
			$(".j-clone-data-loading-spinner").addClass("hidden");
			if (formHtml !== undefined) {
				// @ts-expect-error
				$("#j-clone-game-fields").html($(formHtml).children());
				// Trigger select2 for this Game template select right away, otherwise it would only happen
				// in `updateAutogeneratedActorsList` (via below `$('#actors_number').trigger('keyup')`), which usually takes a while
				pp.backend.formHelpers.initSelect2For($("#game_cloned_from_id"));
				pp.backend.formHelpers.initDateTimePicker(); // this will not have any effect here for Game Tokens with a lobby because of the class `j-manual-datetime-init-date`
				$("form#new_game").validate();
				// re-init the client side validators now that the fields in the modal are visible
				$(".j-init-cloning-button, #game_name").prop("disabled", false);
				// @ts-expect-error
				$("a.popover-action").popover(); // init newly inserted helper popovers
				$("#actors_number").trigger("keyup"); // trigger fetch of Actors table
			} else {
				// Expect data.errorHtml
				pp.notifications.display("error", errorHtml);
				if (redirectUrl !== undefined) {
					$("#error-modal").one("hidden.bs.modal", () => {
						Turbolinks.visit(redirectUrl);
					});
				}
			}
		});
	},

	additionalModeratorsManagement: {
		blankTagHtml:
			'<div class="Tag Tag--lila Tag--with-right-floating-button" data-mod-email=""></div>',
		removeTagHtml:
			'<span class="Tag__remove-tag j-remove-additional-moderator">&times;</span>',

		fields: ".j-add-moderator-fields",
		additionalModeratorsInputs: ".j-additional-moderators",
		additionalModeratorsTags: ".j-additional-moderator-tags",
		nameField: "#new_waiting_co_mod_in_lobby_name",
		emailField: "#new_waiting_co_mod_in_lobby_email",

		init() {
			$(".j-add-additional-moderator").on("click", this.handleAddClick);
			$(
				"input[name^='waiting_co_moderators_in_lobby'][name$='name]']:not(#j-waiting-mod-blank-name)",
			).each(function () {
				pp.backend.gameCloning.additionalModeratorsManagement.addVisually(
					// @ts-expect-error
					this.value,
					$(this).attr("data-mod-email"),
				);
			});
		},

		addVisually(name, email) {
			const module = pp.backend.gameCloning.additionalModeratorsManagement;
			const $newTag = $(module.blankTagHtml)
				.text(name)
				.attr("data-mod-email", email)
				.attr("title", email)
				.append(module.removeTagHtml);
			$(module.additionalModeratorsTags).append($newTag);
			$newTag.on(
				"click",
				pp.backend.gameCloning.additionalModeratorsManagement.handleRemoveClick,
			);
		},

		addInputFieldPair(name, email) {
			const module = pp.backend.gameCloning.additionalModeratorsManagement;

			const $lastModInputField = $("input[data-mod-email]").last();
			if ($lastModInputField.length) {
				// NB strip all non-numeric characters from the `name` attribute
				var indexOfNewInputFields =
					parseInt(
						// @ts-expect-error
						$("input[data-mod-email]").last().attr("name").replace(/\D/g, ""),
						10,
					) + 1;
			} else {
				var indexOfNewInputFields = 1;
			}
			const $nameInputToAppend = $("#j-waiting-mod-blank-name")
				.clone()
				.attr("value", name)
				.removeAttr("id")
				.attr("data-mod-email", email);
			const $emailInputtoAppend = $("#j-waiting-mod-blank-email")
				.clone()
				.attr("value", email)
				.removeAttr("id")
				.attr("data-mod-email", email);
			$nameInputToAppend.attr(
				"name",
				// @ts-expect-error
				$nameInputToAppend.attr("name").replace("000", indexOfNewInputFields),
			);
			$emailInputtoAppend.attr(
				"name",
				// @ts-expect-error
				$emailInputtoAppend.attr("name").replace("000", indexOfNewInputFields),
			);
			$(module.additionalModeratorsInputs).append($nameInputToAppend);
			$(module.additionalModeratorsInputs).append($emailInputtoAppend);
		},

		handleAddClick(event) {
			// pp.log("into addModeratorToClone", event);

			const module = pp.backend.gameCloning.additionalModeratorsManagement;
			const email = $(module.emailField).val();
			const name = $(module.nameField).val();

			// Check non existing
			const $existingEl = $(`[data-mod-email='${email}']`);
			if ($existingEl.length || _.isEmpty(email) || _.isEmpty(name)) {
				return;
			}

			const signupStatusCallback = ({ status_code, games_of_user_names }) => {
				// The status code `email_taken` will mean that an account with that email exists with the *correct* role, because of below argument 'moderator'
				// in the call `pp.users.checkUserEmailRemotely`. Otherwise it will be `email_taken_by_different_role`
				if (["email_available", "email_taken"].includes(status_code)) {
					module.addInputFieldPair(name, email);
					module.addVisually(name, email);
					if ($("#game_token_id").length) {
						// Link mod User to GameToken (and create them for that end if they don't exist yet)
						pp.backend.gameCloning.saveTokenConfig();
					}

					// Reset inputs
					$(module.emailField).val("");
					$(module.nameField).val("");

					// Only auto-show the popover upon adding the very first entry
					if ($(module.additionalModeratorsInputs).children().length != 1) {
						return;
					}
					// @ts-expect-error
					$(".j-co-mod-tooltip").popover("show");
					setTimeout(() => {
						// @ts-expect-error
						$(".j-co-mod-tooltip").popover("hide");
					}, 7500);
				} else if (status_code == "email_taken_by_different_role") {
					let errorString = `${I18n.t("activerecord.attributes.user.email")} ${I18n.t("activerecord.errors.models.user.exists_but_does_not_have_whitelisted_mod_role")}`;
					if (games_of_user_names) {
						errorString += `<br>${I18n.t("activerecord.models.cloned_game.one")}: ${games_of_user_names}`;
					}
					// @ts-expect-error
					$("#new_game")[0].ClientSideValidations.addError(
						$(module.emailField),
						errorString,
					);
				} else {
					// @ts-expect-error
					$("#new_game")[0].ClientSideValidations.addError(
						$(module.emailField),
						`${I18n.t("activerecord.attributes.user.email")} ${I18n.t("activerecord.errors.messages.invalid")}`,
					);
				}
			};

			// Call `pp.users.checkUserEmailRemotely` with a callback function to first check remotely whether the email is valid
			pp.users.checkUserEmailRemotely(
				$(module.emailField),
				signupStatusCallback,
				{ whitelisted_role: "moderator" },
			);
		},

		handleRemoveClick({ target }) {
			const $target = $(target);
			const email = $target.parents(".Tag").attr("data-mod-email");
			// Remove both the tag and the input entry from the hidden array
			$(`[data-mod-email='${email}']`).remove();
			// Unlink mod User from GameToken (and remvoe them if it was their only GameToken)
			if ($("#game_token_id").length) {
				pp.backend.gameCloning.saveTokenConfig();
				pp.gameTokenLobby.sendViaPrivatePub({
					kickUser: true,
					userEmail: email,
				});
			}
		},
	},

	initValidators() {
		const validators = {
			"game[name]": pp.viewHelpers.clientSideValidatorsFor("game", "name"),
			unassigned_users: {
				numericality: [
					{
						equal_to: 0,
						messages: {
							equal_to: I18n.t("user_manager.assign_all_users"),
						},
					},
				],
			},
			new_waiting_co_mod_in_lobby_name: pp.viewHelpers.clientSideValidatorsFor(
				"new_co_mod",
				"name",
			),
		};
		Object.entries(validators).forEach(([inputName, validatorProps]) => {
			$("#new_game").data("clientSideValidations").validators[inputName] =
				validatorProps;
		});

		// ClientSideValidations can't handle selects apparently
		pp.backend.gameCloning.addLocalesSelectValidator(
			$("#new_game").find(`select[name='game[available_locales][]']`),
		);
	},

	addLocalesSelectValidator($selectFields) {
		const $form = $selectFields.closest("form");
		$selectFields.on("change", (event) => {
			pp.log("check");
			if ($(event.target).val() == null) {
				pp.log("hit", $selectFields);
				$form[0].ClientSideValidations.addError(
					$selectFields,
					I18n.t("errors.messages.required"),
				);
			} else {
				$form[0].ClientSideValidations.removeError($selectFields);
			}
		});
	},

	handleActorsNumberChange(e) {
		if (e.keyCode == 13 || (e.keyCode === undefined && e.type == "change")) {
			// enter or focusout (?)
			e.preventDefault();
			e.stopPropagation();
			return;
		}

		// disable 'create game' button until ajax is done
		$(".j-init-cloning-button").prop("disabled", true);
		// wait 500ms before actually getting the list so that the user has time to change the number
		if (pp.backend.gameCloning.getAutogeneratedListTimeout) {
			clearTimeout(pp.backend.gameCloning.getAutogeneratedListTimeout);
			pp.backend.gameCloning.getAutogeneratedListTimeout = null;
		}
		pp.backend.gameCloning.getAutogeneratedListTimeout = setTimeout(
			pp.backend.gameCloning.updateAutogeneratedActorsList,
			750,
		);
	},

	updateAutogeneratedActorsList() {
		// Load table of actor templates that would be cloned to fit the selected number
		$("#actors_number").prop("disabled", true);
		$(".j-lobby-auto-assign-users").prop("disabled", true).addClass("disabled");
		const thisGameId = $("#game_cloned_from_id").val();

		$.getJSON(
			`/games/${thisGameId}/auto_select_actors`,
			{
				actor_tpls_number: $("#actors_number").val(),
				game_token: $("#game_token").val(), // Might be nil
			},
			({ actorIds, html }) => {
				if (actorIds !== false) {
					// `!= false` will not work O.o
					// @ts-expect-error
					$("#new_game")[0].ClientSideValidations.removeError(
						$("#actors_number"),
					); // In case there was one
					$(".j-actors-auto-generated-table").html(html);
					// select correct (calculated) actors of the chosen game tpl
					$("#game_actor_tpl_ids")
						.children("option")
						.each(function () {
							$(this).prop(
								"selected",
								actorIds.indexOf(parseInt(this.value)) != -1,
							);
						});
					$("#game_actor_tpl_ids").trigger("change");
					// In case this is being called in a Game Token lobby
					if ($("#unassigned_users").length) {
						pp.backend.userManager.updateLobbyCounts();
					}
					$(document).trigger("page:change"); // for tablesorter init
				} else {
					if (html == false) {
						// @ts-expect-error
						$("#new_game")[0].ClientSideValidations.addError(
							$("#actors_number"),
							I18n.t(
								"backend.game_cloning_fields.flash.actors_no_not_in_range",
							),
						);
					} else {
						pp.notifications.display("error", html);
					}
				}
			},
		).always(() => {
			$("#actors_number").prop("disabled", false);
			$(".j-lobby-auto-assign-users")
				.prop("disabled", false)
				.removeClass("disabled");
			clearTimeout(pp.backend.gameCloning.getAutoGeneratedListTimeout);
			pp.backend.gameCloning.getAutogeneratedListTimeout = null;
		});
	},

	saveTokenConfig(callback) {
		const gameTokenId = $("#game_token_id").val();
		if (!gameTokenId) {
			console.error(
				"Call stack for calling game_tokens/undefined",
				new Error().stack,
			);
			return;
		}

		const gameTokenData = {
			preset_game_cloning_props: {
				name: $("#game_name").val(),
				start_date: $("#game_start_date").val(),
				selected_game_tpl_id: $("#game_cloned_from_id").val(),
				available_locales: $("#game_available_locales option:selected")
					.map(function () {
						// @ts-expect-error
						return this.value;
					})
					.get(),
			},
			waiting_users_in_lobby: {},
			excluded_generic_user_ids: pp.gameTokenLobby.excludedGenericUserIds,
		};

		$(".j-additional-moderators")
			.children()
			.serializeArray()
			.forEach(({ name, value }) => {
				gameTokenData[name] = value;
			});

		if (
			pp.gameTokenLobby.userData &&
			Object.keys(pp.gameTokenLobby.userData).length
		) {
			Object.keys(pp.gameTokenLobby.userData).forEach((userId) => {
				// @ts-expect-error
				if (isNaN(userId)) {
					// userId might actually be the `observeChangeHandlers` hash
					return;
				}

				gameTokenData.waiting_users_in_lobby[userId] = {
					actor_tpl_id: pp.gameTokenLobby.userData[userId].actorId,
				};
			});
		}

		pp.log(
			"into saveTokenConfig -- gameTokenData, callback",
			gameTokenData,
			callback,
		);

		$.ajax({
			url: `/game_tokens/${gameTokenId}`,
			type: "PUT",
			dataType: "json",
			data: { game_token: gameTokenData },
		})
			// @ts-expect-error
			.success(() => {
				if (callback !== undefined) {
					callback();
				}
			})
			.error(
				({ status, responseText, statusText }, textStatus, errorThrown) => {
					if (callback !== undefined) {
						callback(status, JSON.parse(responseText).message || statusText); // in case of `Consul::Powerless` there will be no `jqXHR.responseText.message`
					}
				},
			);
	},

	displayPostCloneMessages(errorLevel, message, clonedGameUrl) {
		const $cloningModal = $("#game-cloning-progress-modal");
		let className = errorLevel;
		if (errorLevel == "error") {
			className = "danger";
		}
		if ($cloningModal.length) {
			$cloningModal
				.find(".alert")
				.addClass("alert-" + className)
				.html(message);
			if (clonedGameUrl !== undefined) {
				$(".j-redirect-button")
					.attr("href", clonedGameUrl)
					.removeClass("hidden");
			} else {
				$(".j-close-modal-button").removeClass("hidden");
			}
		} else {
			pp.notifications.display("error", message);
		}
	},

	monitorProgress: {
		init(fayeSubscription, queuePosition, gameToken) {
			if ($("#game-cloning-progress-modal").length) {
				$("#confirm-clone-settings").modal("hide");
				$("#game-cloning-progress-modal").modal("show");
			}
			// For the "inline" progress on tables i.e. in elternquiz, or one click cloning.
			$(".j-game-creation-message").removeClass("hidden");
			$("#new_game")
				.find("select, input:not([type='hidden']), .j-init-cloning-button")
				.prop("disabled", true);
			// Only for autogen on demand from users_actors_list
			if (gameToken !== undefined && gameToken != "") {
				this.gameToken = gameToken;
				$(`.RecordIndex__item[data-token='${this.gameToken}']`)
					.find("button")
					.addClass("disabled")
					.prop("disabled", true);
			}

			$("#j-game-cloning-progress-text").html(
				`${I18n.t("backend.game_cloning_fields.in_line_at", { position: queuePosition })}`,
			);

			PrivatePub.sign(fayeSubscription);
			PrivatePub.subscribe(fayeSubscription.channel, function (data, channel) {
				if (data !== undefined) {
					pp.backend.gameCloning.monitorProgress.handleProgressData(data);
				}
			});
		},

		handleProgressData(data) {
			// pp.log("into handleProgressData", data);
			$("#j-game-cloning-progress-text").html(data.message);
			if (data.warnings !== undefined) {
				$("#j-game-cloning-progress-text").html(
					I18n.t(
						"backend.game_cloning_fields.flash.game_was_cloned_with_warnings",
					),
				);
				const warningMessages = `${I18n.t("backend.game_cloning_fields.flash.game_was_cloned_with_warnings")}<br>${data.warnings.join("<br>")}`;
				pp.backend.gameCloning.displayPostCloneMessages(
					"warning",
					warningMessages,
					data.redirect_url,
				);
			} else if (data.errors !== undefined) {
				$("#j-game-cloning-progress-text").html(
					I18n.t(
						"backend.game_cloning_fields.flash.game_was_cloned_with_errors",
					),
				);
				const errorMessages = `${I18n.t("backend.game_cloning_fields.flash.game_was_cloned_with_errors")}<br>${data.errors.join("<br>")}`;
				pp.backend.gameCloning.displayPostCloneMessages("error", errorMessages);
			} else if (data.mod_login_url !== undefined) {
				// For moderators: Expect an Actor login path (`login_actor_path`) which can only be opened via AJAX.
				// `actors#login` will do a hard refresh of the page
				setTimeout(() => {
					$.ajax(data.mod_login_url);
				}, 3000);
			} else if (data.redirect_url !== undefined) {
				// For admins or managers
				window.location.href = data.redirect_url;
			} else if (data.new_subscription !== undefined) {
				const newSubscriptionJSON = JSON.parse(data.new_subscription);
				pp.backend.gameCloning.monitorProgress.init(newSubscriptionJSON);
			}
		},
	},
};
